import React from 'react';

function AudioPlayer({ audioUrl, fileName }) {
  const handleDownload = async () => {
    try {
      // For public R2 URLs, we can download directly via link
      const isPublicUrl = audioUrl && (audioUrl.includes('.r2.dev') || audioUrl.includes('r2.cloudflarestorage'));

      if (isPublicUrl) {
        // Direct download for public URLs
        const a = document.createElement('a');
        a.href = audioUrl;
        a.download = fileName || 'audio.wav';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        // Fetch with auth for private URLs
        const token = localStorage.getItem('authToken');
        const response = await fetch(audioUrl, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName || 'audio.wav';
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
      }
    } catch (error) {
      console.error('Error downloading audio:', error);
    }
  };

  return (
    <div className="space-y-4">
      {/* Audio Player */}
      <div className="player-container">
        <audio
          controls
          className="w-full"
          src={audioUrl}
          controlsList="nodownload"
        >
          Your browser does not support the audio element.
        </audio>
      </div>

      <button
        onClick={handleDownload}
        className="btn-download"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
        </svg>
        <span>Download Audio</span>
      </button>
    </div>
  );
}

export default AudioPlayer;
